import {
    Box,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Stack,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import {
    Button,
    Card,
    FormControl,
    FormLabel,
    Input,
    LoadingIndicator,
    Text,
} from '@/components/v4';
import getService from 'API/Service/getService';
import {
    breadCrumbStyling,
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { useQuery } from 'hooks/useCustomQuery';

export default function EightByEightServiceView() {
    const { id: serviceId } = useParams();
    const navigate = useNavigate();
    const { darkMode } = useSelector((state) => state.settings);

    const { data: serviceObj, isLoading } = useQuery({
        queryKey: ['8x8ServiceView', serviceId],
        queryFn: async () => {
            const res = await getService(serviceId);
            return res.data;
        },
        enabled: !!serviceId,
        refetchOnWindowFocus: false,
    });

    if (isLoading) return <LoadingIndicator />;

    return (
        <Box maxWidth="1064px" position="relative">
            <Breadcrumb sx={breadCrumbStyling}>
                <BreadcrumbItem>
                    <BreadcrumbLink
                        onClick={() => navigate('/dashboard-services')}>
                        Dashboard
                    </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink>8x8 Service</BreadcrumbLink>
                </BreadcrumbItem>
            </Breadcrumb>

            <Card
                borderRadius={15}
                p="30px"
                maxWidth="895px"
                ml={0}
                mt={2}
                bg={darkMode ? 'dark.tcap' : null}>
                <FormControl sx={{ margin: '0 !important' }}>
                    <Stack
                        direction="row"
                        spacing={stackSpacing}
                        sx={stackStyling(true)}>
                        <Box>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                8x8 Service Provider ID
                            </FormLabel>

                            <Text
                                sx={descriptionStyling}
                                mt={2}
                                color={darkMode ? 'gray.400' : 'gray.500'}>
                                The assigned 8x8 service provider. This cannot
                                be changed.
                            </Text>
                        </Box>
                        <Box
                            flex="1"
                            minWidth="450px"
                            sx={{ paddingTop: '15px' }}>
                            <Input
                                value={serviceObj?.serviceProviderID ?? '—'}
                                isReadOnly
                                _focus={{ boxShadow: 'none' }}
                                cursor="default"
                                opacity={0.8}
                            />
                        </Box>
                    </Stack>
                </FormControl>
            </Card>

            <Stack direction="row" spacing={3} mt={5}>
                <Button variant="outline" onClick={() => navigate(-1)}>
                    Back
                </Button>
            </Stack>
        </Box>
    );
}
